// extracted by mini-css-extract-plugin
module.exports = {"StatBoard":"StatBoard_StatBoard__XqM4_","titleStatBoard":"StatBoard_titleStatBoard__2XQrz","selectField":"StatBoard_selectField___ef1o"};